import { LogIn } from 'lucide-react';

import { LoginFormProps } from '../../types/Login/auth.types';

const LoginForm = ({
  employeeCode,
  loading,
  error,
  onEmployeeCodeChange,
  onSubmit,
}: LoginFormProps) => {
  return (
    <form
      onSubmit={onSubmit}
      className="
        w-full
        space-y-[clamp(0.75rem,1.2vw,1rem)]
      "
    >
      {/* Employee Code */}
      <div
        className="
          relative
          mt-[clamp(1rem,1.5vw,1.25rem)]
        "
      >
        <label
          htmlFor="employeeCode"
          className="
            absolute
            -top-2
            left-3
            z-10

            rounded-lg
            border
            border-white/50
            bg-white/70

            px-2
            py-0.5

            text-[clamp(8px,0.65vw,10px)]
            font-bold
            uppercase
            tracking-[0.15em]

            text-blue-700
            backdrop-blur-md
          "
        >
          Employee Code
        </label>

        <input
          id="employeeCode"
          type="text"
          value={employeeCode}
          onChange={(e) =>
            onEmployeeCodeChange(
              e.target.value,
            )
          }
          placeholder="Enter Employee Code"
          className="
            h-[clamp(40px,3.2vw,48px)]
            w-full

            rounded-xl

            border
            border-slate-200

            bg-white/80

            px-[clamp(0.75rem,1vw,1rem)]

            text-[clamp(12px,0.9vw,14px)]
            text-slate-800

            outline-none

            placeholder:text-slate-400

            transition-all
            duration-200

            focus:border-blue-500
            focus:bg-white
            focus:ring-2
            focus:ring-blue-500/20

            hover:border-slate-300
          "
          autoComplete="username"
          required
        />
      </div>

      {/* Error */}
      {error && (
        <div
          className="
            rounded-lg

            border
            border-red-100

            bg-red-50

            px-3
            py-1.5

            text-[clamp(10px,0.75vw,12px)]
            leading-5

            text-red-500
          "
        >
          {error}
        </div>
      )}

      {/* Sign In Button */}
      <button
        type="submit"
        disabled={loading}
        className="
          flex

          h-[clamp(40px,3.2vw,48px)]
          w-full

          items-center
          justify-center

          gap-1.5

          rounded-xl

          bg-blue-600

          px-4

          text-[clamp(12px,0.9vw,14px)]
          font-semibold
          text-white

          shadow-sm

          transition-all
          duration-200

          hover:bg-blue-700
          hover:shadow-md

          active:scale-[0.99]

          disabled:cursor-not-allowed
          disabled:opacity-50
        "
      >
        <LogIn
          size={16}
          strokeWidth={2}
        />

        <span>
          {loading
            ? 'Signing In...'
            : 'Sign In'}
        </span>
      </button>
    </form>
  );
};

export default LoginForm;